"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var actions = _interopRequireWildcard(require("./../store/actions"));

var constants = _interopRequireWildcard(require("./../store/constants"));

var _compositionsModal = _interopRequireDefault(require("@eig-builder/compositions-modal"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _context = _interopRequireDefault(require("./../context"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

require("./lang");

var ConfirmDialog = function ConfirmDialog(props) {
  var _useContext = (0, _react.useContext)(_context["default"]),
      dispatch = _useContext.dispatch;

  var close = function close(buttonType) {
    if (props.beforeClose) {
      props.beforeClose();
    }

    dispatch(props.modals.closeModal(props.modalKey)); // call the callback for this button type

    if (props[buttonType]) {
      props[buttonType]();
    }

    if (props.afterClose) {
      props.afterClose();
    }
  };

  var getPrimaryButton = function getPrimaryButton(buttonType, buttonTitle) {
    var confirmButtonCustomStyle = props.confirmButtonCustomStyle;
    return _react["default"].createElement(_Button["default"], {
      color: "primary",
      key: "primary",
      tag: buttonType,
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "core--confirm-dialog--primary-button",
      dataElementId: "core--confirm-dialog--primary-button",
      onClick: function onClick() {
        return close(buttonType);
      },
      className: confirmButtonCustomStyle && confirmButtonCustomStyle !== '' ? confirmButtonCustomStyle : ''
    }, buttonTitle && buttonTitle !== '' ? buttonTitle : _react["default"].createElement(_moduleLocalization["default"], {
      message: 'core.modals.components.confirmDialog.' + buttonType
    }));
  };

  getPrimaryButton.propTypes = {
    confirmButtonCustomStyle: _propTypes["default"].string
  };

  var getSecondaryButton = function getSecondaryButton(buttonType) {
    return _react["default"].createElement(_Button["default"], {
      variant: "outlined",
      key: buttonType,
      tag: buttonType,
      onClick: function onClick() {
        return close(buttonType);
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "core--confirm-dialog--secondary-button",
      dataElementId: "core--confirm-dialog--secondary-button"
    }, _react["default"].createElement(_moduleLocalization["default"], {
      message: 'core.modals.components.confirmDialog.' + buttonType
    }));
  };

  var getDialogModel = function getDialogModel() {
    var actions = [];

    switch (props.type) {
      case constants.YES_NO:
        {
          actions = [getSecondaryButton('no'), getPrimaryButton('yes')];
          break;
        }

      case constants.YES_NO_CANCEL:
        {
          actions = [getSecondaryButton('cancel'), getSecondaryButton('no'), getPrimaryButton('yes')];
          break;
        }

      case constants.OK:
        {
          actions = [getPrimaryButton('ok')];
          break;
        }

      case constants.OK_CANCEL:
        {
          actions = [getSecondaryButton('cancel'), getPrimaryButton('ok')];
          break;
        }

      case constants.SAVE:
        {
          actions = [getSecondaryButton('cancel'), getPrimaryButton('save')];
          break;
        }

      case constants.CONFIRM:
        {
          actions = [getPrimaryButton('confirm', props.buttonTitle || 'confirm')];
          break;
        }

      case constants.CANCEL_CONFIRM:
        {
          actions = [getSecondaryButton('cancel'), getPrimaryButton('confirm', props.buttonTitle || 'confirm')];
          break;
        }
    }

    return {
      actions: actions
    };
  };

  var dialogActions = getDialogModel();
  return _react["default"].createElement(_compositionsModal["default"], {
    variant: props.variant,
    maxWidth: props.maxWidth,
    height: "auto",
    open: props.open,
    onClose: function onClose() {
      return close('cancel');
    },
    title: props.title,
    withContentBorder: true,
    fullScreen: false,
    actions: dialogActions.actions
  }, props.content);
};

ConfirmDialog.propTypes = {
  modals: _propTypes["default"].object,
  open: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].string,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  modalKey: _propTypes["default"].number,
  afterClose: _propTypes["default"].func,
  beforeClose: _propTypes["default"].func,
  type: _propTypes["default"].string,
  buttonTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  variant: _propTypes["default"].string
};
ConfirmDialog.defaultProps = {
  open: true,
  confirmButtonStyle: {},
  className: '',
  maxWidth: 'sm',
  variant: 'default'
};

var wrapper = function wrapper(props) {
  return _react["default"].createElement(ConfirmDialog, (0, _extends2["default"])({}, props, {
    modals: actions
  }));
};

var _default = wrapper;
exports["default"] = _default;